import gql from "graphql-tag"

export const DELETE_ZAVER_CONFIG = gql`
  mutation deleteZaverConfig($id: ID!) {
    deleteZaverConfig(id: $id) {
      status
    }
  }
`
